import React from "react"
import "./account.css"
import { getUserCity, getUserEmail, getUserMobile, getUserName, getUserStatus } from "../../utils/localStorage";

const UserView = () => {

    
    return(
        <div className='accountDetails'>
        <div className='accountField'>
            <div className='accountFieldName'>
                Name
            </div>
            <div className='accountData'>
                {getUserName()}
            </div>
        </div>
        <div className='accountField'>
            <div className='accountFieldName'>
                Status
            </div>
            <div className='accountData'>
                {getUserStatus()}
            </div>
        </div>
        {getUserMobile()?
            <div className='accountField'>
                <div className='accountFieldName'>
                    Phone Number
                </div>
                <div className='accountData'>
                    {getUserMobile()}
                </div>
            </div>
        :""}
        <div className='accountField'>
            <div className='accountFieldName'>
                Email
            </div>
            <div className='accountData'>
                {getUserEmail()}
            </div>
        </div>
        {getUserCity()?
            <div className='accountField'>
                <div className='accountFieldName'>
                    City
                </div>
                <div className='accountData'>
                    {getUserCity()}
                </div>
            </div>
        :""}
    </div>
    )
}

export default UserView;


// WEBPACK FOOTER //
// ./src/components/Account/UserView.js